module.exports = __webpack_public_path__ + "static/media/pack-ur-bags-contrast.96482df7.png";